<script lang="ts">
	import type { PromotionBlock } from '$models/Block/PromotionBlock';
	import PromotionSlider from '$components/Block/Promotion/PromotionSlider.svelte';
	import PromotionWithUsps from '$components/Block/Promotion/PromotionWithUsps.svelte';

	// FYI: On mobile we always have 75% ratio, on desktop we have 75% ratio with 3 or 4 items. For the 2 items grid we have 100% ratio.
	// FYI: When filled property is true, the image is covered over the item with a aspect ratio of 16/9 (portrait) for for mobile and 2/3 for desktop. 100% ratio for the 2 items grid as well.
	//TODO Video option did I already frontend but is out of scope for now. Leave it for now.
	// Video remains local to the existing prototype markup and is not exposed by the V1 CMS model.
	interface Props {
		block: PromotionBlock;
	}

	const { block }: Props = $props();
	const title = $derived(block.title ?? undefined);
	const items = $derived(block.items);
	const withUsps = $derived(block.withUsps);
	const uspBlock = $derived(block.uspBlock);
</script>

{#if withUsps && uspBlock}
	<PromotionWithUsps {items} {uspBlock} />
{:else}
	<PromotionSlider {items} {title} />
{/if}
